import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyLayoutBrannan = loadable(() => import(/* webpackChunkName: "content/guest/layouts/brannan" */ './LayoutBrannan'), 'LayoutBrannan');
